import * as ko from "knockout";
import entityBase from 'entityBase';

export class c_product_structure_serials_view extends entityBase {

    internal_descriptn: KnockoutObservable<string>;
    main_serial_id: KnockoutObservable<string>;
    serial_id: KnockoutObservable<string>;
    old_serial_id: string;
    part_id: KnockoutObservable<string>;
    product_structure_id: KnockoutObservable<string>;
    structure_category: KnockoutObservable<string>;


    constructor(item: any) {
        super();
        this.internal_descriptn = ko.observable(item.internal_descriptn);
        this.main_serial_id = ko.observable(item.main_serial_id);
        this.serial_id = ko.observable(item.serial_id);
        this.part_id = ko.observable(item.part_id);
        this.product_structure_id = ko.observable(item.product_structure_id);
        this.structure_category = ko.observable(item.structure_category);
        this.old_serial_id = item.serial_id;
    }
}


